import { Language } from "../context/LanguageContext";

export interface InfiniteInsightTranslations {
  title: {
    firstLine: string;
    secondLine: string;
  };
  introduction: string;
  sections: {
    description: string;
  }[];
}

export const getInfiniteInsightTranslations = (
  language: Language
): InfiniteInsightTranslations => {
  switch (language) {
    default:
      return {
        title: {
          firstLine: "The infinite",
          secondLine: "delivery of insight",
        },
        introduction: `This extraordinary sculpture of an Aquamarine Obelisk and the Morganite Turtle, is based on a short Novel of Niveau élevé, playing in the middle of the ancient Northern Mythology. The gist of it is, that during the time of conflict between the two main Tribes of Nordic Godheads, the Wanes and the Asen, both had created magic stones to upgrade the intellectual and moral progress of mankind which was spreading over "Middle-Earth". The Asen had created the Philosopher's Stone, and the Wanes the Obelisk of Insight.

But in the confusion of the war, the Philospher's Stone got lost in the valley of Gleymsku, in a crevice where the walkyrie Sigrun had first hidden it, but then never found it again. The Obelisk of Insight also got stuck in the same valley, through which the magic turtle Framfarir Framferar was trying to carry it to mankind, when the walkyrie Sigrun closed the valley with a spell to prevent that somebody would find the Philosopher's stone.

So "insight" has still not reached mankind, and mankind is still waiting for its moral and mental progress.`,
        sections: [
          {
            description:
              "The magnificent Morganite of extraordinary purity and colour comes with a certificate of GIA New York, stating that it weighs 1276,3 grams or 6381,5 carats.",
          },
          {
            description:
              "The Aquamarine Obelisk comes with a GIA certificate stating that it weighs 717,6 grams, which is 3588 carats. According to the Gem-stone Library of GIA it is the third-largest Aquamarine known.",
          },
          {
            description:
              "The sculpture of the turtle with the Aquamarine Obelisk, has been cut, polished and engraved by Jürgen Christmann and Iris Hartenberger from Idar Oberstein during the high-time of Cronoa.",
          },
          {
            description:
              "The Aquamarine Obelisk comes with a GIA certificate stating that it weighs 717,6 grams, which is 3588 carats. According to the Gem-stone Library of GIA it is the third-largest Aquamarine known.  The Aquamarine-Morganite group was polished and carved by Jüren Christmann and Iris Hartenberger.",
          },
        ],
      };
  }
}; 